import axios from "axios";
import { gqlClient } from "../configs/api-config";

export { normalizeData, orderStatus, setAxiosAndGqlToken };

function normalizeData(swrData) {
  return swrData && swrData.data;
}

function orderStatus(status: string) {
  switch (status) {
    case "submitted_by_customer":
    case "submitted_by_crm":
      return {
        text: "سبد خرید",
        color: "common.black",
      };
    case "ready_to_collect":
      return {
        text: "سفارش ثبت شده",
        color: "secondary.main",
      };
    case "collected":
      return {
        text: "تحویل گرفته شده",
        color: "green.dark",
      };
    case "collection_not_present":
      return {
        text: "عدم حضور",
        color: "red.main",
      };
    case "unwrapped":
      return {
        text: "آماده شستشو",
        color: "primary.dark",
      };
    case "in_progress":
      return {
        text: "در حال انجام",
        color: "primary.dark",
      };
    case "work_done":
      return {
        text: "تعیین زمان تحویل",
        color: "secondary.main",
      };
    case "ready_to_deliver":
      return {
        text: "آماده تحویل‌",
        color: "green.main",
      };
    case "delivery_not_present":
      return {
        text: "عدم حضور",
        color: "red.main",
      };
    case "delivered":
      return {
        text: "تحویل داده شد",
        color: "green.main",
      };
    case "canceled_by_customer":
    case "canceled_by_system":
      return {
        text: "کنسل شده",
        color: "red.main",
      };
    case "delivery_canceled":
      return {
        text: "تحویل لغو شده",
        color: "red.main",
      };
    case "collection_canceled":
      return {
        text: "جمع‌آوری لغو شده",
        color: "red.main",
      };
    default:
      return {
        text: "نامشخص",
        color: "common.black",
      };
  }
}

function setAxiosAndGqlToken(token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  gqlClient.setHeader("Authorization", "Bearer " + token);
}
